import { useDarkMode } from "../ThemeContext";
import ThemedReaderFrame from "../components/ThemedReaderFrame";
import React, { useState, useRef, useCallback } from "react";
import vachanList from "../data/vachanall.json";
import vatoList from "../data/vatochapter7.json";
import vatoList2 from "../data/vatochapter8-16.json";
import bhajanData from "../data/bhajan.json";
import quotesData from "../data/quotes.json";
import { shikshapatriData } from "../data/shikshapatriData";
import paramrutData from "../data/paramrut1.json";
import priteData from "../data/pbp.json";
import "../styles/Pages.css";
import "../styles/Vachanamrut.css";

import auData from "../data/ambrishupnishad-1.json";
import bsaList from "../data/bsa.json";

// -- AnirdeshiAmrut data imports --
import aa1_1 from "../data/aa1_achaman1.json";
import aa1_2 from "../data/aa1_achaman2.json";
import aa1_3 from "../data/aa1_achaman3.json";
import aa1_4 from "../data/aa1_achaman4.json";
import aa1_5 from "../data/aa1_achaman5.json";
import aa1_6 from "../data/aa1_achaman6.json";
import aa2_1 from "../data/aa2_achaman1.json";
import aa2_2 from "../data/aa2_achaman2.json";
import aa2_3 from "../data/aa2_achaman3.json";
import aa3_1 from "../data/aa3_achaman1.json";
import aa3_2 from "../data/aa3_achaman2.json";
import aa3_3 from "../data/aa3_achaman3.json";
import aa3_4 from "../data/aa3_achaman4.json";

const PBP_INDEX_URL = "/data/pbp-index.json";


const SERIES = [
  {
    id: 1,
    label: "Anirdeshi Amrut 1",
    achamans: [aa1_1, aa1_2, aa1_3, aa1_4, aa1_5, aa1_6],
  },
  {
    id: 2,
    label: "Anirdeshi Amrut 2",
    achamans: [aa2_1, aa2_2, aa2_3],
  },
  {
    id: 3,
    label: "Anirdeshi Amrut 3",
    achamans: [aa3_1, aa3_2, aa3_3, aa3_4],
  },
];

const ALL_AA = SERIES.flatMap((s) =>
  s.achamans.flatMap((achamanItems, idx) =>
    achamanItems.map((item) => ({
      ...item,
      _series: s.id,
      _seriesLabel: s.label,
      _achaman: idx + 1,
    })),
  ),
);

const bhajanList = Object.values(bhajanData);

const ALL_AU = auData.map((item) => ({
  ...item,
  tags: (item.tags || "")
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean),
}));

// filename -> metadata lookup for paramrut
const PARAMRUT_META = Object.fromEntries(
  paramrutData.map((p) => [p.prvfile, p]),
);

const PRITE_CHAPTERS = [
  "૧. સત્સંગ",
  "૨. ધર્મ, નિયમ, સદાચાર",
  "૩. અભાવ-અવગુણ, દ્રોહ",
  "૪. આજ્ઞાપાલન",
  "૫. પરબ્રહ્મ પુરુષોત્તમનારાયણ",
  "૬. ભક્તિ, એકાંતિક ધર્મ",
  "૭. નિર્દોષબુદ્ધિ, દિવ્યભાવ",
  "૮. હેત-પ્રીત",
  "૯. નિર્માનીપણું",
  "૧૦. અક્ષરબ્રહ્મ",
  "૧૧. ખપ - સહનશીલતા",
  "૧૨. ભક્ત",
  "૧૩. દાસપણું",
  "૧૪. નિષ્કામવ્રત, બ્રહ્મચર્ય",
  "૧૫. એકાંતિક સત્પુરુષ",
  "૧૬. દેહભાવ",
  "૧૭. સંસાર",
  "૧૮. અસત્પુરુષ, અસાધુ",
  "૧૯. ગુરુ",
  "૨૦. ત્યાગી સાધુ",
  "૨૧. પ્રગટ",
  "૨૨. ઉપાસના-નિશ્ચય-આશરો",
  "૨૩. શ્રીહરિનો સ્વાભાવિક ગુણ",
  "૨૪. માન-મોટપ",
  "૨૫. સુખ-દુઃખ",
  "૨૬. પંચવિષય",
  "૨૭. માયા",
  "૨૮. કપટ નિષ્કપટ",
  "૨૯. શ્રીહરિની રુચિ, સ્વાભાવિક ગુણ",
];

const priteChapterNameFor = (chapterId) =>
  PRITE_CHAPTERS[chapterId - 1] || "Prite";

const PRITE_META = Object.fromEntries(
  priteData.map((item) => [item.filename, item]),
);

const ROMAN_CONSONANTS = {
  ksh: "ક્ષ",
  chh: "છ",
  kh: "ખ",
  gh: "ઘ",
  ch: "ચ",
  jh: "ઝ",
  th: "થ",
  dh: "ધ",
  ph: "ફ",
  bh: "ભ",
  sh: "શ",
  gn: "જ્ઞ",
  tr: "ત્ર",
  ny: "ન્ય",
  ng: "ઙ",
  k: "ક",
  g: "ગ",
  c: "ક",
  j: "જ",
  t: "ત",
  d: "દ",
  n: "ન",
  p: "પ",
  b: "બ",
  m: "મ",
  y: "ય",
  r: "ર",
  l: "લ",
  v: "વ",
  w: "વ",
  s: "સ",
  h: "હ",
  f: "ફ",
  q: "ક",
  x: "ક્સ",
  z: "ઝ",
};
const ROMAN_VOWELS = {
  aa: { independent: "આ", matra: "ા" },
  ai: { independent: "ઐ", matra: "ૈ" },
  au: { independent: "ઔ", matra: "ૌ" },
  ii: { independent: "ઈ", matra: "ી" },
  ee: { independent: "ઈ", matra: "ી" },
  oo: { independent: "ઊ", matra: "ૂ" },
  uu: { independent: "ઊ", matra: "ૂ" },
  a: { independent: "અ", matra: "" },
  i: { independent: "ઇ", matra: "િ" },
  u: { independent: "ઉ", matra: "ુ" },
  e: { independent: "એ", matra: "ે" },
  o: { independent: "ઓ", matra: "ો" },
};
const GUJARATI_ROMAN = {
  અ: "a",
  આ: "aa",
  ઇ: "i",
  ઈ: "i",
  ઉ: "u",
  ઊ: "u",
  ઋ: "ri",
  એ: "e",
  ઐ: "ai",
  ઓ: "o",
  ઔ: "au",
  ક: "k",
  ખ: "kh",
  ગ: "g",
  ઘ: "gh",
  ઙ: "ng",
  ચ: "ch",
  છ: "chh",
  જ: "j",
  ઝ: "jh",
  ઞ: "ny",
  ટ: "t",
  ઠ: "th",
  ડ: "d",
  ઢ: "dh",
  ણ: "n",
  ત: "t",
  થ: "th",
  દ: "d",
  ધ: "dh",
  ન: "n",
  પ: "p",
  ફ: "ph",
  બ: "b",
  ભ: "bh",
  મ: "m",
  ય: "y",
  ર: "r",
  લ: "l",
  ળ: "l",
  વ: "v",
  શ: "sh",
  ષ: "sh",
  સ: "s",
  હ: "h",
};
const GUJARATI_MATRAS = {
  "ા": "aa",
  "િ": "i",
  "ી": "i",
  "ુ": "u",
  "ૂ": "u",
  "ૃ": "ri",
  "ે": "e",
  "ૈ": "ai",
  "ો": "o",
  "ૌ": "au",
};

function normalizeRoman(text) {
  return (text || "")
    .toLowerCase()
    .replace(/[^a-z]/g, "")
    .replace(/aa/g, "a")
    .replace(/ee|ii/g, "i")
    .replace(/oo|uu/g, "u")
    .replace(/sh/g, "s")
    .replace(/ph/g, "f")
    .replace(/bh/g, "b")
    .replace(/dh/g, "d")
    .replace(/th/g, "t")
    .replace(/chh/g, "ch")
    .replace(/v/g, "w");
}

function normalizeGujarati(text) {
  return (text || "")
    .toLowerCase()
    .replace(/[િી]/g, "િ")
    .replace(/[ુૂ]/g, "ુ")
    .replace(/[ેૈ]/g, "ે")
    .replace(/[ોૌ]/g, "ો")
    .replace(/[ંઃઁ]/g, "ં")
    .replace(/[શષસ]/g, "સ")
    .replace(/ળ/g, "લ");
}

function romanToGujarati(text) {
  const input = (text || "").toLowerCase().replace(/[^a-z\s]/g, "");
  const vowels = Object.keys(ROMAN_VOWELS).sort((a, b) => b.length - a.length);
  const consonants = Object.keys(ROMAN_CONSONANTS).sort(
    (a, b) => b.length - a.length,
  );
  let output = "";
  let index = 0;

  while (index < input.length) {
    if (/\s/.test(input[index])) {
      output += " ";
      index += 1;
      continue;
    }
    const remaining = input.slice(index);
    const vowel = vowels.find((token) => remaining.startsWith(token));
    if (vowel) {
      output += ROMAN_VOWELS[vowel].independent;
      index += vowel.length;
      continue;
    }
    const consonant = consonants.find((token) => remaining.startsWith(token));
    if (!consonant) {
      index += 1;
      continue;
    }
    output += ROMAN_CONSONANTS[consonant];
    index += consonant.length;
    const afterConsonant = input.slice(index);
    const nextVowel = vowels.find((token) => afterConsonant.startsWith(token));
    if (nextVowel) {
      output += ROMAN_VOWELS[nextVowel].matra;
      index += nextVowel.length;
    }
  }
  return output;
}

function gujaratiToRoman(text) {
  const input = text || "";
  let output = "";
  for (let index = 0; index < input.length; index += 1) {
    const character = input[index];
    const next = input[index + 1] || "";
    if (/[\u0A95-\u0AB9]/.test(character)) {
      const consonant = GUJARATI_ROMAN[character];
      if (!consonant) continue;
      if (GUJARATI_MATRAS[next]) {
        output += consonant + GUJARATI_MATRAS[next];
        index += 1;
      } else if (next === "્") {
        output += consonant;
        index += 1;
      } else {
        output += `${consonant}a`;
      }
      continue;
    }
    if (GUJARATI_ROMAN[character]) {
      output += GUJARATI_ROMAN[character];
      continue;
    }
    if (GUJARATI_MATRAS[character]) {
      output += GUJARATI_MATRAS[character];
      continue;
    }
    if (character === "ં" || character === "ઁ") output += "m";
    else if (character === "ઃ") output += "h";
    else output += " ";
  }
  return normalizeRoman(output.replace(/a(\s|$)/g, "$1"));
}

function buildSearchPayload(query) {
  const trimmed = (query || "").trim();
  const terms = new Set([trimmed.toLowerCase()]);
  const highlightTerms = new Set([trimmed]);
  const isGujarati = /[\u0A80-\u0AFF]/.test(trimmed);
  const isRoman = !isGujarati && /^[a-z\s]+$/i.test(trimmed);
  if (isGujarati) {
    terms.add(normalizeGujarati(trimmed));
  } else if (isRoman) {
    const transliterated = romanToGujarati(trimmed);
    if (transliterated) {
      terms.add(transliterated.toLowerCase());
      terms.add(normalizeGujarati(transliterated));
      highlightTerms.add(transliterated);
    }
  }
  return {
    query: trimmed,
    terms: Array.from(terms).filter(Boolean),
    highlightTerms: Array.from(highlightTerms).filter(Boolean),
    isRoman,
    romanQuery: normalizeRoman(trimmed),
  };
}

function matchesSearchText(text, payload) {
  const source = text || "";
  const lowerText = source.toLowerCase();
  const normalizedText = normalizeGujarati(source);
  const matchesText = payload.terms.some(
    (term) => lowerText.includes(term) || normalizedText.includes(term),
  );
  return (
    matchesText ||
    (payload.isRoman &&
      payload.romanQuery &&
      gujaratiToRoman(source).includes(payload.romanQuery))
  );
}

function pickHighlightWord(text, payload) {
  const source = (text || "").toLowerCase();
  return (
    payload.highlightTerms.find(
      (term) => term && source.includes(term.toLowerCase()),
    ) || payload.query
  );
}

// -- Markup strippers for snippet extraction --
function cleanShikshapatri(html) {
  return html
    .replace(/<br\s*\/?>/gi, " ")
    .replace(/।।[\d।]+।।/g, "")
    .trim();
}

function cleanVachan(raw) {
  return raw
    .replace(/\$\{Title\}[^$]*/g, "")
    .replace(/\{Slok\}/g, " ")
    .replace(/\$/g, " ")
    .replace(/\*#|#\*/g, "")
    .trim();
}

function cleanVato(raw) {
  const atIdx = raw.indexOf("@");
  const main = atIdx !== -1 ? raw.slice(0, atIdx) : raw;
  return main
    .replace(/\$\$/g, " ")
    .replace(/\$/g, " ")
    .replace(/#ex1|\/#ex1/g, "")
    .trim();
}

function getSnippet(text, word) {
  const idx = text.toLowerCase().indexOf(word.toLowerCase());
  if (idx === -1)
    return text.slice(0, 160).trim() + (text.length > 160 ? "…" : "");
  const start = Math.max(0, idx - 80);
  const end = Math.min(text.length, idx + word.length + 80);
  let snippet = text.slice(start, end).trim();
  if (start > 0) snippet = "…" + snippet;
  if (end < text.length) snippet += "…";
  return snippet;
}

function Highlighted({ text, word }) {
  if (!word.trim()) return <>{text}</>;
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const regex = new RegExp(`(${escaped})`, "gi");
  const parts = text.split(regex);
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? <mark key={i}>{part}</mark> : part,
      )}
    </>
  );
}

function renderVachanText(raw, word) {
  const paras = raw.split("$").reduce((acc, p) => {
    const t = p.trim();
    if (!t || t.startsWith("{Title}")) return acc;
    const clean = t
      .replace(/\{Slok\}/g, " ")
      .replace(/\*#|#\*/g, "")
      .trim();
    if (clean) acc.push(clean);
    return acc;
  }, []);
  return (
    <div className="sw-modal-text">
      {paras.map((p, i) => (
        <p key={i}>
          <Highlighted text={p} word={word} />
        </p>
      ))}
    </div>
  );
}

function renderAAText(raw, word) {
  const paras = raw
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
  return (
    <div className="sw-modal-text">
      {paras.map((p, i) => (
        <p key={i}>
          <Highlighted text={p} word={word} />
        </p>
      ))}
    </div>
  );
}

function renderVatoText(raw, word) {
  const atIdx = raw.indexOf("@");
  const main = atIdx !== -1 ? raw.slice(0, atIdx) : raw;
  const glossaryRaw = atIdx !== -1 ? raw.slice(atIdx + 1) : "";
  const cleanMain = main
    .replace(/#ex1\s*/g, "")
    .replace(/\s*\/#ex1/g, "")
    .trim();
  const glossaryItems = glossaryRaw
    .replace(/\$\$/g, "\n")
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);
  return (
    <div className="sw-modal-text">
      <p>
        <Highlighted text={cleanMain} word={word} />
      </p>
      {glossaryItems.length > 0 && (
        <div className="sw-modal-glossary">
          <hr className="sw-modal-divider" />
          {glossaryItems.map((g, i) => (
            <p key={i} className="sw-modal-gloss-item">
              {g}
            </p>
          ))}
        </div>
      )}
    </div>
  );
}

function renderShikshapatriModal(item, word) {
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`(${escaped})`, "gi");
  const highlight = (html) =>
    html.replace(
      re,
      '<mark style="background:#ffe066;color:#222;border-radius:2px">$1</mark>',
    );
  return (
    <div className="sw-modal-text">
      <p
        dangerouslySetInnerHTML={{ __html: highlight(item.sanskrit) }}
        style={{ fontStyle: "italic", color: "#555" }}
      />
      <p dangerouslySetInnerHTML={{ __html: highlight(item.gujarati) }} />
    </div>
  );
}

function TextModal({ modal, word, onClose }) {
  if (!modal) return null;
  const { title, nameGuj, rawText, loading, type, shikshaItem } = modal;
  const activeWord = modal.highlightWord || word;
  let body;
  if (type === "shikshapatri") {
    body = shikshaItem
      ? renderShikshapatriModal(shikshaItem, activeWord)
      : null;
  } else if (type === "brahm") {
    const q = modal.brahmItem;
    body = q ? (
      <div className="sw-modal-text">
        <p style={{ lineHeight: 1.9 }}>
          <Highlighted text={q.quote} word={activeWord} />
        </p>
        {q.guru && (
          <p className="reader-accent" style={{ fontWeight: 600, color: "#667eea", marginTop: 10 }}>
            {q.guru}
          </p>
        )}
        {q.date && (
          <p className="reader-muted" style={{ fontSize: "0.9em", color: "#666" }}>
            {q.date}
            {q.place ? ` · ${q.place}` : ""}
          </p>
        )}
      </div>
    ) : null;
  } else if (type === "kirtan") {
    body = (
      <ThemedReaderFrame
        src={modal.kirtanUrl}
        title={title}
        style={{
          width: "100%",
          height: "60vh",
          border: "none",
          borderRadius: "6px",
        }}
        sandbox="allow-same-origin"
      />
    );
  } else if (loading) {
    body = <p className="sw-modal-loading">Loading…</p>;
  } else if (!rawText) {
    body = <p className="sw-modal-loading">Could not load content.</p>;
  } else if (type === "vachan") {
    body = renderVachanText(rawText, activeWord);
  } else if (type === "aa") {
    body = renderAAText(rawText, activeWord);
  } else if (type === "prasang" || type === "paramrut") {
    body = (
      <div
        className="reader-html"
        dangerouslySetInnerHTML={{
          __html: renderPrasangHtml(rawText, activeWord),
        }}
        style={{
          fontFamily: "inherit",
          lineHeight: 1.9,
          wordBreak: "break-word",
        }}
      />
    );
  } else {
    body = renderVatoText(rawText, activeWord);
  }
  return (
    <div className="sw-modal-backdrop" onClick={onClose}>
      <div className="sw-modal-box" onClick={(e) => e.stopPropagation()}>
        <button className="sw-modal-close" aria-label="Close reader" onClick={onClose}>
          ✕
        </button>
        <div className="sw-modal-header">
          <div className="sw-modal-title">{title}</div>
          {nameGuj && <div className="sw-modal-subtitle">{nameGuj}</div>}
        </div>
        <div className="sw-modal-body">{body}</div>
      </div>
    </div>
  );
}

function ResultSection({ title, colorClass, count, children }) {
  return (
    <div className="sw-section">
      <div className="sw-section-header">
        <span className={`sw-badge ${colorClass}`}>{title}</span>
        <span className="sw-section-count">
          {count} result{count !== 1 ? "s" : ""}
        </span>
      </div>
      {children}
    </div>
  );
}

function renderPrasangHtml(html, word) {
  if (!word.trim()) return html;
  const escaped = word.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const re = new RegExp(`(${escaped})`, "gi");
  return html
    .replace(/<script[\s\S]*?<\/script>/gi, "")
    .replace(/<ul[^>]*class="reader_tools[^"]*"[^>]*>[\s\S]*?<\/ul>/i, "")
    .replace(
      re,
      '<mark style="background:#ffe066;color:#222;border-radius:2px">$1</mark>',
    );
}

export default function SearchWord() {
  const [query, setQuery] = useState("");
  const [searching, setSearching] = useState(false);
  const [results, setResults] = useState(null);
  const [modal, setModal] = useState(null);
  const [selectedResultKey, setSelectedResultKey] = useState(null);
  const [darkMode, setDarkMode] = useDarkMode();
  const vachanIdxRef = useRef(null);
  const vatoIdxRef = useRef(null);
  const vato2IdxRef = useRef(null);
  const kirtanIdxRef = useRef(null);
  const prasangIdxRef = useRef(null);
  const paramrutIdxRef = useRef(null);
  const priteIdxRef = useRef(null);
  const bsaIdxRef = useRef(null);

  const openAAModal = useCallback(
    ({ title, nameGuj, content, highlightWord }) => {
      setModal({
        title,
        nameGuj,
        rawText: content,
        loading: false,
        type: "aa",
        highlightWord,
      });
    },
    [],
  );

  const openShikshapatriModal = useCallback(
    ({ title, item, highlightWord }) => {
      setModal({
        title,
        nameGuj: "",
        rawText: null,
        loading: false,
        type: "shikshapatri",
        shikshaItem: item,
        highlightWord,
      });
    },
    [],
  );

  const openModal = useCallback(
    async ({ title, nameGuj, url, type, highlightWord }) => {
      setModal({
        title,
        nameGuj,
        rawText: null,
        loading: true,
        type,
        highlightWord,
      });
      try {
        const res = await fetch(url);
        const rawText = await res.text();
        setModal((m) => ({ ...m, rawText, loading: false }));
      } catch {
        setModal((m) => ({ ...m, loading: false }));
      }
    },
    [],
  );

  const openPrasangModal = useCallback(
    async ({ title, file, highlightWord }) => {
      setModal({
        title,
        nameGuj: "",
        rawText: null,
        loading: true,
        type: "prasang",
        highlightWord,
      });
      try {
        const res = await fetch(
          `${process.env.PUBLIC_URL}/data/prasang/${file}`,
        );
        const rawText = await res.text();
        setModal((m) => ({ ...m, rawText, loading: false }));
      } catch {
        setModal((m) => ({ ...m, loading: false }));
      }
    },
    [],
  );

  const openParamrutModal = useCallback(
    async ({ title, file, highlightWord }) => {
      setModal({
        title,
        nameGuj: "",
        rawText: null,
        loading: true,
        type: "paramrut",
        highlightWord,
      });
      try {
        const res = await fetch(
          `${process.env.PUBLIC_URL}/data/paramrut/${file}`,
        );
        const rawText = await res.text();
        setModal((m) => ({ ...m, rawText, loading: false }));
      } catch {
        setModal((m) => ({ ...m, loading: false }));
      }
    },
    [],
  );

  const doSearch = useCallback(async (q) => {
    const payload = buildSearchPayload(q);
    if (!payload.query) return;
    setSearching(true);
    setResults(null);
    setSelectedResultKey(null);

    try {
      if (!vachanIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/vachan-index.json`,
        );
        if (!response.ok) throw new Error("Could not load vachan index");
        vachanIdxRef.current = await response.json();
      }
      if (!vatoIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/vato-index.json`,
        );
        if (!response.ok) throw new Error("Could not load vato index");
        vatoIdxRef.current = await response.json();
      }
      if (!vato2IdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/vato2-index.json`,
        );
        if (!response.ok) throw new Error("Could not load vato2 index");
        vato2IdxRef.current = await response.json();
      }
      if (!prasangIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/prasang-index.json`,
        );
        if (!response.ok) throw new Error("Could not load prasang index");
        prasangIdxRef.current = await response.json();
      }
      if (!paramrutIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/paramrut-index.json`,
        );
        if (!response.ok) throw new Error("Could not load paramrut index");
        paramrutIdxRef.current = await response.json();
      }
      if (!kirtanIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/kirtan-index.json`,
        );
        if (!response.ok) throw new Error("Could not load kirtan index");
        kirtanIdxRef.current = await response.json();
      }
      if (!priteIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}${PBP_INDEX_URL}`,
        );
        if (!response.ok) throw new Error("Could not load prite index");
        priteIdxRef.current = await response.json();
      }
      if (!bsaIdxRef.current) {
        const response = await fetch(
          `${process.env.PUBLIC_URL}/data/bsa-index.json`,
        );
        if (!response.ok) throw new Error("Could not load bsa index");
        bsaIdxRef.current = await response.json();
      }

      const vachan = [];
      for (const entry of vachanIdxRef.current) {
        if (!matchesSearchText(entry.content, payload)) continue;
        const vachanItem = vachanList.find(
          (item) =>
            item.File.replace(/\.html$/i, ".txt").toLowerCase() ===
            entry.file.toLowerCase(),
        );
        if (!vachanItem) continue;
        const cleaned = cleanVachan(entry.content);
        const highlightWord = pickHighlightWord(cleaned, payload);
        vachan.push({
          id: vachanItem.Id,
          name: vachanItem.VachanName,
          nameGuj: vachanItem.NameGuj,
          snippet: getSnippet(cleaned, highlightWord),
          highlightWord,
          file: entry.file,
        });
      }

      const vato = [];
      for (const entry of vatoIdxRef.current) {
        if (!matchesSearchText(entry.content, payload)) continue;
        const vatoItem = vatoList.find(
          (item) =>
            item.VatFile.replace(/\.html$/i, ".txt").toLowerCase() ===
              entry.file.toLowerCase() && item.ChId === entry.chId,
        );
        if (!vatoItem) continue;
        const cleaned = cleanVato(entry.content);
        const highlightWord = pickHighlightWord(cleaned, payload);
        vato.push({
          id: vatoItem.VatId,
          name: `Pr.${vatoItem.ChId} · ${vatoItem.VatNo}. ${vatoItem.VatName}`,
          nameGuj: vatoItem.VatNameGuj,
          snippet: getSnippet(cleaned, highlightWord),
          highlightWord,
          file: entry.file,
          chId: entry.chId,
        });
      }

      const vato2 = [];
      for (const entry of vato2IdxRef.current) {
        if (!matchesSearchText(entry.content, payload)) continue;
        const vatoItem = vatoList2.find(
          (item) =>
            item.VatFile.replace(/\.html$/i, ".txt").toLowerCase() ===
              entry.file.toLowerCase() && item.ChId === entry.chId,
        );
        if (!vatoItem) continue;
        const cleaned = cleanVato(entry.content);
        const highlightWord = pickHighlightWord(cleaned, payload);
        vato2.push({
          id: vatoItem.VatId,
          name: `Pr.${vatoItem.ChId} · ${vatoItem.VatNo}. ${vatoItem.VatName}`,
          nameGuj: vatoItem.VatNameGuj,
          snippet: getSnippet(cleaned, highlightWord),
          highlightWord,
          file: entry.file,
          chId: entry.chId,
        });
      }

      const paramrut = paramrutIdxRef.current
        .filter((entry) => matchesSearchText(entry.text, payload))
        .map((entry) => {
          const meta = PARAMRUT_META[entry.file];
          const label = meta
            ? `${meta.prvtitle} · ${meta.prvdate}${meta.prvplace ? ` · ${meta.prvplace}` : ""}`
            : entry.file;
          const highlightWord = pickHighlightWord(entry.text, payload);
          return {
            file: entry.file,
            title: label,
            snippet: getSnippet(entry.text, highlightWord),
            highlightWord,
          };
        });

      const prasang = prasangIdxRef.current
        .filter((entry) => matchesSearchText(entry.text, payload))
        .map((entry) => {
          const highlightWord = pickHighlightWord(entry.text, payload);
          return {
            file: entry.file,
            title: entry.title || entry.file,
            snippet: getSnippet(entry.text, highlightWord),
            highlightWord,
          };
        });

      const brahm = quotesData
        .filter(
          (item) =>
            matchesSearchText(item.quote, payload) ||
            matchesSearchText(item.guru, payload),
        )
        .map((item) => {
          const highlightWord = pickHighlightWord(item.quote, payload);
          return {
            number: item.number,
            snippet: getSnippet(item.quote, highlightWord),
            highlightWord,
            item,
          };
        });

      const kirtan = [];
      for (const entry of kirtanIdxRef.current) {
        if (!matchesSearchText(entry.content, payload)) continue;
        const bhajan = bhajanList.find((item) => item.sid === entry.sid);
        if (!bhajan) continue;
        const highlightWord = pickHighlightWord(entry.content, payload);
        kirtan.push({
          sid: bhajan.sid,
          name: bhajan.subtitle,
          nameGuj: bhajan.title,
          snippet: getSnippet(entry.content, highlightWord),
          highlightWord,
          lyrics: bhajan.lyrics,
        });
      }

      const shikshapatri = shikshapatriData
        .filter((item) => {
          const sanskrit = cleanShikshapatri(item.sanskrit);
          const gujarati = cleanShikshapatri(item.gujarati);
          return (
            matchesSearchText(sanskrit, payload) ||
            matchesSearchText(gujarati, payload)
          );
        })
        .map((item) => {
          const gujarati = cleanShikshapatri(item.gujarati);
          const highlightWord = pickHighlightWord(gujarati, payload);
          return {
            number: item.number,
            snippet: getSnippet(gujarati, highlightWord),
            highlightWord,
            item,
          };
        });

      const aa = ALL_AA.filter(
        (item) =>
          matchesSearchText(item.content || "", payload) ||
          matchesSearchText(item.title || "", payload),
      ).map((item) => {
        const content = item.content || "";
        const highlightWord = pickHighlightWord(content, payload);
        return {
          id: `${item._series}-${item.id}`,
          name: `${item._seriesLabel} · #${item.id}`,
          nameGuj: item.title || "",
          snippet: getSnippet(content, highlightWord),
          highlightWord,
          content,
        };
      });

      const au = ALL_AU.filter(
        (item) =>
          matchesSearchText(item.content || "", payload) ||
          matchesSearchText(item.title || "", payload),
      ).map((item) => {
        const content = item.content || "";
        const highlightWord = pickHighlightWord(content, payload);
        return {
          id: item.srno,
          name: `${item.prakaran} · #${item.srno}`,
          nameGuj: item.title || "",
          snippet: getSnippet(content, highlightWord),
          highlightWord,
          content,
        };
      });

      const prite = priteIdxRef.current
        .filter((entry) => matchesSearchText(entry.text, payload))
        .map((entry) => {
          const meta = PRITE_META[entry.file];
          const highlightWord = pickHighlightWord(entry.text, payload);
          return {
            id: meta?.id || entry.file,
            title: priteChapterNameFor(meta?.chapterid),
            nameGuj: meta?.title || entry.file,
            snippet: getSnippet(entry.text, highlightWord),
            highlightWord,
            file: entry.file,
          };
        });

      const bsa = [];
      for (const entry of bsaIdxRef.current) {
        if (!matchesSearchText(entry.content, payload)) continue;
        const item = bsaList.find((bsaItem) => bsaItem.id === entry.id);
        if (!item) continue;
        const highlightWord = pickHighlightWord(entry.content, payload);
        bsa.push({
          id: item.id,
          name: `${item.chaptername} · ${item.prasangno}. ${item.prasangtitle}`,
          nameGuj: item.personname,
          snippet: getSnippet(entry.content, highlightWord),
          highlightWord,
          file: item.prasangfile,
        });
      }

      setResults({
        vachan,
        vato,
        vato2,
        kirtan,
        brahm,
        aa,
        au,
        prasang,
        paramrut,
        shikshapatri,
        prite,
        bsa,
      });
    } catch (error) {
      console.error(error);
      setResults({
        vachan: [],
        vato: [],
        vato2: [],
        kirtan: [],
        brahm: [],
        aa: [],
        au: [],
        prasang: [],
        paramrut: [],
        shikshapatri: [],
        prite: [],
        bsa: [],
      });
    } finally {
      setSearching(false);
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    doSearch(query);
  };

  const handleClear = () => {
    setQuery("");
    setResults(null);
    setSelectedResultKey(null);
  };

  const total = results
    ? results.vachan.length +
      results.vato.length +
      results.vato2.length +
      results.kirtan.length +
      results.brahm.length +
      results.aa.length +
      results.au.length +
      results.prasang.length +
      results.paramrut.length +
      results.shikshapatri.length +
      results.prite.length +
      results.bsa.length
    : 0;

  const getSectionListClass = (count) =>
    count > 10
      ? "word-results-list search-results-scroll-list"
      : "word-results-list";
  const getResultItemClass = (itemKey) =>
    selectedResultKey === itemKey
      ? "word-result-item active"
      : "word-result-item";
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <main
      className={`page-content vachanamrut-page search-word-page scripture-reader${darkMode ? " sv-dark" : ""}`}
    >
      <section className="page-header">
        <h1 className="section-title">Search Word</h1>
        <p className="header-subtitle">
          શિક્ષાપત્રી · વચનામૃત · સ્વામીની વાતો · અનિર્દેશિ અમૃત · અંબરીષ ઉપનિષદ
          · ભેદે સાક્ષી અંતનતા · હરિ પ્રબોધમ પ્રસંગ · બ્રહ્મરત્ન · કીર્તન ·
          અક્ષરવાણી / પરામૃત
        </p>
      </section>

      <form className="word-search-bar" onSubmit={handleSubmit}>
        <input
          className="word-search-input"
          type="text"
          placeholder="Search word across all Granth"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <button type="submit" className="word-search-btn" disabled={searching}>
          {searching ? "Searching…" : "Search"}
        </button>
        {results !== null && (
          <button
            type="button"
            className="word-search-clear"
            onClick={handleClear}
          >
            ✕ Clear
          </button>
        )}
        <button
          type="button"
          className="word-search-clear"
          onClick={() => setDarkMode((value) => !value)}
          title="Toggle light/dark mode"
        >
          {darkMode ? "Light" : "Dark"}
        </button>
      </form>

      {results !== null && (
        <div className="word-results-panel">
          {total === 0 ? (
            <p className="word-results-empty">
              No results found for "{query}".
            </p>
          ) : (
            <>
              <p className="word-results-count">
                {total} result{total !== 1 ? "s" : ""} for "{query}"
              </p>

              {results.shikshapatri.length > 0 && (
                <ResultSection
                  title="Shikshapatri"
                  colorClass="sw-badge-shiksha"
                  count={results.shikshapatri.length}
                >
                  <ul
                    className={getSectionListClass(results.shikshapatri.length)}
                  >
                    {results.shikshapatri.map((r) => (
                      <li
                        key={r.number}
                        className={getResultItemClass(`shiksha-${r.number}`)}
                        onClick={() => {
                          setSelectedResultKey(`shiksha-${r.number}`);
                          openShikshapatriModal({
                            title: `શિક્ષાપત્રી ।।${r.number}।।`,
                            item: r.item,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">
                            Shikshapatri ।।{r.number}।।
                          </span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.vachan.length > 0 && (
                <ResultSection
                  title="Vachanamrut"
                  colorClass="sw-badge-vachan"
                  count={results.vachan.length}
                >
                  <ul className={getSectionListClass(results.vachan.length)}>
                    {results.vachan.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(
                          `vachan-${r.file}-${r.id}`,
                        )}
                        onClick={() => {
                          setSelectedResultKey(`vachan-${r.file}-${r.id}`);
                          openModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            url: `${process.env.PUBLIC_URL}/data/textvachan/${r.file}`,
                            type: "vachan",
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.vato.length > 0 && (
                <ResultSection
                  title="Swamini Vato"
                  colorClass="sw-badge-vato"
                  count={results.vato.length}
                >
                  <ul className={getSectionListClass(results.vato.length)}>
                    {results.vato.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(
                          `vato-${r.chId}-${r.file}-${r.id}`,
                        )}
                        onClick={() => {
                          setSelectedResultKey(
                            `vato-${r.chId}-${r.file}-${r.id}`,
                          );
                          openModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            url: `${process.env.PUBLIC_URL}/data/textvato/chapter${r.chId}/${r.file}`,
                            type: "vato",
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.vato2.length > 0 && (
                <ResultSection
                  title="Swamini Vato 2"
                  colorClass="sw-badge-vato2"
                  count={results.vato2.length}
                >
                  <ul className={getSectionListClass(results.vato2.length)}>
                    {results.vato2.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(
                          `vato2-${r.chId}-${r.file}-${r.id}`,
                        )}
                        onClick={() => {
                          setSelectedResultKey(
                            `vato2-${r.chId}-${r.file}-${r.id}`,
                          );
                          openModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            url: `${process.env.PUBLIC_URL}/data/textvato/chapter${r.chId}/${r.file}`,
                            type: "vato",
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.aa.length > 0 && (
                <ResultSection
                  title="Anirdeshi Amrut"
                  colorClass="sw-badge-aa"
                  count={results.aa.length}
                >
                  <ul className={getSectionListClass(results.aa.length)}>
                    {results.aa.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(`aa-${r.id}`)}
                        onClick={() => {
                          setSelectedResultKey(`aa-${r.id}`);
                          openAAModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            content: r.content,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.au.length > 0 && (
                <ResultSection
                  title="Ambrish Upnishad"
                  colorClass="sw-badge-aa"
                  count={results.au.length}
                >
                  <ul className={getSectionListClass(results.au.length)}>
                    {results.au.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(`au-${r.id}`)}
                        onClick={() => {
                          setSelectedResultKey(`au-${r.id}`);
                          openAAModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            content: r.content,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.prasang.length > 0 && (
                <ResultSection
                  title="Hari Prabodham Prasangam"
                  colorClass="sw-badge-prasang"
                  count={results.prasang.length}
                >
                  <ul className={getSectionListClass(results.prasang.length)}>
                    {results.prasang.map((r) => (
                      <li
                        key={r.file}
                        className={getResultItemClass(`prasang-${r.file}`)}
                        onClick={() => {
                          setSelectedResultKey(`prasang-${r.file}`);
                          openPrasangModal({
                            title: r.title,
                            file: r.file,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name-guj">{r.title}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.paramrut.length > 0 && (
                <ResultSection
                  title="Akshar Vani / Paramrut "
                  colorClass="sw-badge-paramrut"
                  count={results.paramrut.length}
                >
                  <ul className={getSectionListClass(results.paramrut.length)}>
                    {results.paramrut.map((r) => (
                      <li
                        key={r.file}
                        className={getResultItemClass(`paramrut-${r.file}`)}
                        onClick={() => {
                          setSelectedResultKey(`paramrut-${r.file}`);
                          openParamrutModal({
                            title: r.title,
                            file: r.file,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name-guj">{r.title}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.kirtan.length > 0 && (
                <ResultSection
                  title="Kirtan / Bhajan"
                  colorClass="sw-badge-kirtan"
                  count={results.kirtan.length}
                >
                  <ul className={getSectionListClass(results.kirtan.length)}>
                    {results.kirtan.map((r) => (
                      <li
                        key={r.sid}
                        className={getResultItemClass(`kirtan-${r.sid}`)}
                        onClick={() => {
                          setSelectedResultKey(`kirtan-${r.sid}`);
                          setModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            rawText: null,
                            loading: false,
                            type: "kirtan",
                            kirtanUrl: `${process.env.PUBLIC_URL}/data/bhajan/${r.lyrics}`,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.brahm.length > 0 && (
                <ResultSection
                  title="Brahm Ratna"
                  colorClass="sw-badge-brahm"
                  count={results.brahm.length}
                >
                  <ul className={getSectionListClass(results.brahm.length)}>
                    {results.brahm.map((r) => (
                      <li
                        key={r.number}
                        className={getResultItemClass(`brahm-${r.number}`)}
                        onClick={() => {
                          setSelectedResultKey(`brahm-${r.number}`);
                          setModal({
                            title: `Brahm Ratna #${r.number}`,
                            nameGuj: r.item.guru,
                            rawText: null,
                            loading: false,
                            type: "brahm",
                            brahmItem: r.item,
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">#{r.number}</span>
                          <span className="vachan-name-guj">{r.item.guru}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.bsa.length > 0 && (
                <ResultSection
                  title="Bhede Sakshi Anantna"
                  colorClass="sw-badge-aa"
                  count={results.bsa.length}
                >
                  <ul className={getSectionListClass(results.bsa.length)}>
                    {results.bsa.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(`bsa-${r.id}`)}
                        onClick={() => {
                          setSelectedResultKey(`bsa-${r.id}`);
                          openModal({
                            title: r.name,
                            nameGuj: r.nameGuj,
                            url: `${process.env.PUBLIC_URL}/data/bsa/${r.file}`,
                            type: "aa",
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.name}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}

              {results.prite.length > 0 && (
                <ResultSection
                  title="Prite"
                  colorClass="sw-badge-aa"
                  count={results.prite.length}
                >
                  <ul className={getSectionListClass(results.prite.length)}>
                    {results.prite.map((r) => (
                      <li
                        key={r.id}
                        className={getResultItemClass(
                          `prite-${r.file}-${r.id}`,
                        )}
                        onClick={() => {
                          setSelectedResultKey(`prite-${r.file}-${r.id}`);
                          openModal({
                            title: r.title,
                            nameGuj: r.nameGuj,
                            url: `${process.env.PUBLIC_URL}/data/pbp/${r.file}`,
                            type: "aa",
                            highlightWord: r.highlightWord,
                          });
                        }}
                      >
                        <div className="word-result-header">
                          <span className="vachan-name">{r.title}</span>
                          <span className="vachan-name-guj">{r.nameGuj}</span>
                        </div>
                        <p className="word-result-snippet">
                          <Highlighted
                            text={r.snippet}
                            word={r.highlightWord || query}
                          />
                        </p>
                      </li>
                    ))}
                  </ul>
                </ResultSection>
              )}
            </>
          )}
        </div>
      )}

      <div className="search-word-top-wrap">
        <button
          type="button"
          className="word-search-clear search-word-top-btn"
          onClick={scrollToTop}
          title="Scroll to top"
        >
          Top
        </button>
      </div>

      <TextModal modal={modal} word={query} onClose={() => setModal(null)} />
    </main>
  );
}
